import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "./App.css";

import Home from "./components/pages/home";
import ComingSoonPage from "./components/pages/comingSoon";
import OurValues from './components/ourValues/ourValues'
import AboutUs from "./components/aboutUs/aboutUs";
import ContactUs from "./components/contactUs/contactUs";
import Footer from "./components/footer/footer";
import Navbar from "./components/navbar/navbar";
import Inspire from "./components/inspire/inspire";

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Router>
      {/* <nav>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/comingSoon">About</Link></li>
        </ul>
      </nav> */}

      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/#introVideo" /> */}
        <Route path="/ourThemes" element={<ComingSoonPage pageName={"Our Themes"} />} />
        <Route path="/ourGuages" element={<ComingSoonPage pageName={"Our Guages"} />} />
        <Route path="/ourHardwareAndDisplays" element={<ComingSoonPage pageName={"Our hardware and displays"} />} />
        <Route path="/designYourOwnGuages" element={<ComingSoonPage pageName={"Design your own guages"} />} />
        <Route path="/guagesForTunedCars" element={<ComingSoonPage pageName={"Guages for tuned cars"} />} />
        <Route path="/evo" element={<ComingSoonPage pageName={"EVO specialized themes and guages"} />} />
        <Route path="/ourWork" element={<ComingSoonPage pageName={"Our work"} />} />
        <Route path="/otherProducts" element={<ComingSoonPage pageName={"Other products"} />} />
        <Route path="/classicGuages" element={<ComingSoonPage pageName={"Classic guages"} />} />
        <Route path="/aboutUs" element={<AboutUs pageName={"About us"} />} />
        <Route path="/contactUs" element={<ContactUs pageName={"Meet our family"} />} />
        <Route path="/ourValues" element={<OurValues pageName={"Our values"} />} />
        <Route path="/inspirations" element={<Inspire pageName={"Our values"} />} />
      </Routes>

      <Footer />

    </Router>

  );
}

export default App;
